var formatAmountFilter = function(amt) {
  var fmtAmt = '' + Math.round(amt)
  var length = fmtAmt.length
  if (length > 3) {
    for (var i = length - 3; i > 0; i = i - 2) {
      fmtAmt = fmtAmt.substr(0, i) + ',' + fmtAmt.substr(i)
    }
  }
  // fmtAmt = fmtAmt
  return fmtAmt
}

var dropDownDirective = {
  inserted: function(el, bindings) {
    el.setAttribute('tabindex', -1)
    var totalOptions = el.childElementCount
    // el.focus()
    el.firstElementChild.classList.add('active')
    // el.firstElementChild.focus()
    var currentOption = 0
    var currentOptionElement = el.firstElementChild
    el.addEventListener('keydown', function(event) {
      event.preventDefault()
      if (event.keyCode === 40) {
        // down key pressed
        if (currentOption === totalOptions - 1) currentOption = -1
        currentOptionElement.classList.remove('active')
        currentOption = ++currentOption % totalOptions
        currentOptionElement = el.children[currentOption]
        currentOptionElement.classList.add('active')
        // currentOptionElement.focus()
        console.log(currentOption)
      } else if (event.keyCode === 38) {
        // up key pressed
        if (currentOption === 0) currentOption = totalOptions
        currentOptionElement.classList.remove('active')
        currentOption = --currentOption % totalOptions
        currentOptionElement = el.children[currentOption]
        currentOptionElement.classList.add('active')
        // currentOptionElement.focus()
        console.log(currentOption)
      }
    })

    el.addEventListener(
      'blur',
      function(event) {
        console.log('blur captured')
        // if (!event.currentTarget.classList.contains('drop-down-option')) {
        // bindings.value.show.show = false
        // }
      },
      true
    )
    console.log(bindings.value)
  }
}

export default [{ type: 'filter', name: 'formatAmount', obj: formatAmountFilter }, { type: 'directive', name: 'dd-options', obj: dropDownDirective }]



// WEBPACK FOOTER //
// ./src/common/common.js